// PdfReport.js
import jsPDF from "jspdf";

const PdfDownload = (questionData, answer, aiSuggestionData) => {
  const doc = new jsPDF("p", "pt", "a4");

  // Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("JobDrona Report", 40, 40);

  // Content template
  const content = `
  <div style="padding:15px; font-family: Arial, sans-serif; font-size:12px; line-height:1.5;">
    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
      <div>
      
     <div>${
       questionData?.category ||
       `${questionData.skillName} | ${questionData.subSkillName}` ||
       ""
     }
        }
      </div>
      <span style="
        background: ${
          questionData?.difficulty === "High"
            ? "#ffcccc"
            : questionData?.difficulty === "Medium"
            ? "lightgreen"
            : "#f0f0f0"
        };
        padding:4px 8px;
        border-radius:6px;">
        ${questionData?.difficulty || ""}
      </span>
    </div>

    <h2 style="margin:10px 0;">${questionData?.questionTitle || ""}</h2>

    <h3 style="margin:8px 0;">Sample Answer</h3>
    <div style="border:1px solid gray; border-radius:6px; padding:10px;">
      <ul style="margin:0; padding-left:18px; list-style:none;">
        ${
          questionData?.sampleAnswerList
            ?.map(
              (s) => `<li style="margin-bottom:6px;">&#8226; ${s}</li>` // bullet char
            )
            .join("") || ""
        }
      </ul>
    </div>

    <h3 style="margin:8px 0;">Your Answer</h3>
    <p style="border:1px solid gray; border-radius:6px; padding:10px; margin:0;">
      ${answer || ""}
    </p>

    <h3 style="margin:8px 0;">AI Suggestion</h3>
    <div style="border:1px solid gray; border-radius:6px; padding:12px;">

      <p><strong>Overall Feedback</strong></p>
      <p>${aiSuggestionData?.overallFeedback || ""}</p>

      <p><strong>Overall Rating</strong></p>
      <p>${aiSuggestionData?.overallRating || ""} / 5</p>

      <p><strong>Strengths</strong></p>
      <ul style="margin:0; padding-left:18px; list-style:none;">
        ${
          aiSuggestionData?.keyStrengths
            ?.map((s) => `<li style="margin-bottom:4px;">&#8226; ${s}</li>`)
            .join("") || ""
        }
      </ul>

      <p><strong>Weakness</strong></p>
      <ul style="margin:0; padding-left:18px; list-style:none;">
        ${
          aiSuggestionData?.weakness
            ?.map((i) => `<li style="margin-bottom:4px;">&#8226; ${i}</li>`)
            .join("") || ""
        }
      </ul>

      <p><strong>Recommended Action</strong></p>
      <ul style="margin:0; padding-left:18px; list-style:none;">
        ${
          aiSuggestionData?.recommendedActions
            ?.map((s) => `<li style="margin-bottom:4px;">&#8226; ${s}</li>`)
            .join("") || ""
        }
      </ul>
    </div>
  </div>
`;

  // Render HTML into PDF
  doc.html(content, {
    callback: function (doc) {
      doc.save("JobDrona_Report.pdf");
    },
    x: 40,
    y: 60,
    width: 500,
    windowWidth: 800,
  });
};

export default PdfDownload;
